import React, { useState, useEffect } from "react";
import TopBar from "./components/TopBar";
import DesktopIcons from "./components/DesktopIcons";
import TodoList from "./components/TodoList";
import Finder from "./components/Finder";
import InfoPage from "./components/InfoPage";
import TextFile from "./components/TextFile";
import AudioFolder from "./components/AudioFolder";
import VideoFolder from "./components/VideoFolder";
import PDFViewer from "./components/PDFViewer";
import ContactMail from "./components/ContactMail";
import Notification from "./components/Notification";
import MusicPlayer from "./components/MusicPlayer";
import ImageViewer from "./components/ImageViewer";
import MobileUnderConstruction from "./components/MobileUnderConstruction";
import "./App.css";

function App() {
  const [activeWindow, setActiveWindow] = useState(null);
  const [windowContent, setWindowContent] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [isPlayerMinimized, setIsPlayerMinimized] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Détecter le redimensionnement
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const defaultPlaylist = [
    { name: "prod1.wav", src: "/audio/prod1.mp3" },
    { name: "prod2.wav", src: "/audio/prod2.mp3" },
    { name: "prod3.wav", src: "/audio/prod3.mp3" },
    { name: "prod4.wav", src: "/audio/prod4.mp3" },
    { name: "prod5.wav", src: "/audio/prod5.mp3" }
  ];

  const [currentTrack, setCurrentTrack] = useState(defaultPlaylist[0]);
  const [playlist, setPlaylist] = useState(defaultPlaylist);
  const [isPlaylistMode, setIsPlaylistMode] = useState(true);

  const openWindow = (type, content = null) => {
    setActiveWindow(type);
    setWindowContent(content);
    setIsPlayerMinimized(true);
  };

  const closeWindow = () => {
    setActiveWindow(null);
    setWindowContent(null);
  };

  const openInfo = () => openWindow("info");
  const openContact = () => openWindow("contact");
  const openFinder = (folderName) => openWindow("finder", folderName);
  const openTextFile = (fileName) => openWindow("textfile", fileName);
  const openAudioFolder = (folderName) => openWindow("audiofolder", folderName);
  const openVideoFolder = (folderName) => openWindow("videofolder", folderName);
  const openPDF = () => openWindow("pdf");
  const openImageViewer = (imageName) => openWindow("imageviewer", imageName);
  const handleLogoClick = () => closeWindow();

  const handleTrashDrop = () => {
    setNotificationMessage("Non ça je vais le garder :)");
    setShowNotification(true);
  };

  const handleMailSent = () => {
    setNotificationMessage("Mail envoyé !");
    setShowNotification(true);
  };

  const handleWorkInProgress = () => {
    setNotificationMessage("En travaux...");
    setShowNotification(true);
  };

  const closeNotification = () => {
    setShowNotification(false);
    setTimeout(() => setNotificationMessage(""), 300);
  };

  const handlePlayTrack = (track, trackList) => {
    setCurrentTrack(track);
    setPlaylist(trackList);
    setIsPlaylistMode(false);
  };

  const handleOpenPlaylist = () => {
    setPlaylist(defaultPlaylist);
    setCurrentTrack(defaultPlaylist[0]);
    setIsPlaylistMode(true);
  };

  const closeMusicPlayer = () => {
    setPlaylist(defaultPlaylist);
    setCurrentTrack(defaultPlaylist[0]);
    setIsPlaylistMode(true);
  };

  // Si mobile, afficher seulement la page en travaux
  if (isMobile) {
    return (
      <div className="App">
        <div 
          className="background-image"
          style={{ backgroundImage: "url('/karelback.jpeg')" }}
        />
        <MobileUnderConstruction />
      </div>
    );
  }

  return (
    <div className="App">
      {activeWindow === "info" ? (
        <video className="background-video" autoPlay loop muted playsInline>
          <source src="/background_info.mp4" type="video/mp4" />
        </video>
      ) : (
        <div 
          className="background-image"
          style={{ backgroundImage: "url('/karelback.jpeg')" }}
        />
      )}

      <TopBar 
        onInfoClick={openInfo} 
        onContactClick={openContact}
        onLogoClick={handleLogoClick}
      />

      <div className="desktop-container">
        {activeWindow !== "info" && <TodoList />}
        {activeWindow !== "info" && (
          <DesktopIcons 
            openFinder={openFinder} 
            openTextFile={openTextFile}
            openAudioFolder={openAudioFolder}
            openVideoFolder={openVideoFolder}
            openPDF={openPDF}
            openImageViewer={openImageViewer}
            onTrashDrop={handleTrashDrop}
            handleOpenPlaylist={handleOpenPlaylist}
            onWorkInProgress={handleWorkInProgress}
          />
        )}
      </div>

      {activeWindow === "finder" && (
        <Finder 
          onClose={closeWindow} 
          folderName={windowContent} 
          onPlayTrack={handlePlayTrack}
        />
      )}
      
      {activeWindow === "info" && (
        <InfoPage onClose={closeWindow} />
      )}

      {activeWindow === "textfile" && (
        <TextFile onClose={closeWindow} fileName={windowContent} />
      )}

      {activeWindow === "audiofolder" && (
        <AudioFolder 
          onClose={closeWindow} 
          folderName={windowContent}
          onPlayTrack={handlePlayTrack}
        />
      )}

      {activeWindow === "videofolder" && (
        <VideoFolder onClose={closeWindow} folderName={windowContent} />
      )}

      {activeWindow === "pdf" && (
        <PDFViewer onClose={closeWindow} />
      )}

      {activeWindow === "imageviewer" && (
        <ImageViewer onClose={closeWindow} imageName={windowContent} />
      )}

      {activeWindow === "contact" && (
        <ContactMail 
          onClose={closeWindow} 
          onMailSent={handleMailSent}
        />
      )}

      <MusicPlayer 
        track={currentTrack}
        playlist={playlist}
        isPlaylistMode={isPlaylistMode}
        onClose={closeMusicPlayer}
        isMinimized={isPlayerMinimized}
        setIsMinimized={setIsPlayerMinimized}
      />

      {showNotification && (
        <Notification 
          message={notificationMessage}
          onClose={closeNotification} 
        />
      )}
    </div>
  );
}

export default App;
